<template>
  <div class="acceptance order-info" id="orderlist">
    <div class="title-order">
      全部订单 /
      <span>处理异常</span>
    </div>
    <div class="goods-info">
      <div class="title-mode title-accept">商品信息</div>
      <div class="goods">
        <div class="goods-tab">
          <div class="shang">商品</div>
          <div class="shuliang">数量</div>
          <div class="baozhuang">包装方式</div>
        </div>

        <div class="goods-list">
          <div
            class="item-goods"
            v-for="(item, index) in orderList.orderItems"
            :key="index"
            v-if="index < indexNum"
          >
            <img :src="item.imgUrl" alt />
            <div class="goods-name">{{ item.name }}</div>
            <div class="goods-num">{{ item.count }}</div>
            <div class="bangzhuang">{{ item.packingMethod }}</div>
          </div>
        </div>
        <div
          class="accept-more"
          v-if="orderList.orderItems.length > 3 && indexNum == 3"
          @click="indexNum = 99"
        >
          查看更多
          <svg class="icon iconbiaodan_rili_left" aria-hidden="true">
            <use xlink:href="#iconbiaodan_rili_left" />
          </svg>
        </div>
      </div>
    </div>

    <div class="applyinfo">
      <div class="title-mode title-accept">异常信息</div>
      <div class="applyinfo-info">
        <div class="tabclass">
          <span class="label">异常内容：</span>
          <div>{{ abnormalData.content }}</div>
        </div>
        <div class="tabclass">
          <span class="label">相关图片：</span>
          <div v-if="imgLis.length">
            <template v-for="(item, index) in abnormalData.imgs">
              <el-image
                v-if="imgOrVideo(item.url).type == 'img'"
                :key="index"
                :src="imgOrVideo(item.url).url"
                :preview-src-list="setPreviewList(imgLis)"
              >
              </el-image>
              <el-image
                style="cursor: pointer"
                v-if="imgOrVideo(item.url).type == 'video'"
                :key="index"
                :src="imgOrVideo(item.url).url"
                @click="openVideo(item.url)"
              >
              </el-image>
              <audio
                v-if="imgOrVideo(item.url).type == 'audio'"
                controls
                :src="imgOrVideo(item.url).url"
              ></audio>
              <a
                v-if="imgOrVideo(item.url).type == 'download'"
                :href="imgOrVideo(item.url).url"
                target="_blank"
                >媒体下载</a
              >
            </template>
            <!-- <img
              v-for="(item, index) in abnormalData.imgs"
              :key="index"
              :src="item.url"
              alt
            /> -->
          </div>
        </div>
      </div>
    </div>

    <div class="abnormal-btn">
      <el-button @click="markupCheck('BACK')">退回商品</el-button>
      <el-button @click="markupCheck('MARKUP')">加价</el-button>
      <el-button @click="markupCheck('NORMAL')">正常服务</el-button>
    </div>

    <!-- 退回商品 -->
    <el-dialog
      title="退回商品"
      @close="cancelArbitration"
      :visible.sync="arbitration"
      width="30%"
      class="arbitration complaint"
    >
      <div>
        <div class="tips">需退回商品请与师傅或物流点联系退回事宜</div>
        <div class="a-title">申请退款</div>
        <div class="arbitration-title" style="margin-bottom: 24px">
          退款原因
          <span style="color: #5e6066">异常订单退款</span>
        </div>
        <div class="arbitration-title">
          订单总金额
          <span>¥{{ orderList.totalAmount }}</span>
        </div>
        <div class="fu-title">· 师傅补贴费</div>
        <el-input
          class="default-input"
          v-model="masterPrice"
          @input="rechargeMoney"
          :placeholder="'最多￥' + orderList.workerCashIntransit + '元'"
        ></el-input>
        <div class="arbitration-tips">师傅补贴费为支付给师傅的费用</div>
        <div class="fu-title">
          · 退款金额
          <span style="color: #f75658"
            >¥{{
              (orderList.totalAmount * 1000 - masterPrice * 1000) / 1000
            }}</span
          >
        </div>
        <div class="arbitration-tips">
          师傅补贴费为支付给师傅的费用，退款金额=订单总金额-师傅补贴费
        </div>
        <div class="arbitration-content">
          <span style="color: #f75658">*</span>详细内容
        </div>
        <el-input
          class="default-input"
          v-model="arbitrationListContent"
          placeholder="请输入详细内容"
          type="textarea"
        ></el-input>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="arbitration = false">取 消</el-button>
        <el-button type="primary" @click="submitarbitration()">提 交</el-button>
      </span>
    </el-dialog>

    <!-- 加价 -->
    <increase-price
      :orderData="orderList"
      :markup="markup"
      :abnormal="abnormal"
      v-on:showMarkup="showMarkup"
      v-on:increasePrice="increasePrice"
    ></increase-price>
    <video-play ref="videoPlay"></video-play>
  </div>
</template>

<script>
import increasePrice from "./increase_price";
import videoPlay from "@/components/user/modules/videoPlay";
import { imgOrVideo } from "@/utils/util";
export default {
  components: {
    increasePrice,
    videoPlay,
  },
  data() {
    return {
      indexNum: 3,
      orderList: {
        orderItems: [],
      },
      abnormalData: {},
      markup: false,
      abnormal: true,
      masterPrice: "",
      arbitration: false,
      arbitrationListContent: "",
      arbitrationList: [],
      arbitrationInfo: {},
      imgLis: [],
    };
  },
  activated() {
    var _this = this;
    for (let i of _this.$store.state.userList) {
      i.isSelected = false;
      if (i.name == "全部订单") {
        i.isSelected = true;
      }
    }
    this.$fetch(`order/api/order/${_this.$route.query.orderid}`).then((res) => {
      if (res.code == 0) {
        _this.orderList = res.data;
      } else {
        this.$message(res.message);
      }
    });
    this.$fetch(
      `order/api/goods_pick_up?oid=${_this.$route.query.orderid}`
    ).then((res) => {
      if (res.code == 0) {
        _this.abnormalData = res.data;
        res.data.imgs.map((i) => {
          _this.imgLis.push(i.url);
        });
      } else {
        this.$message(res.message);
      }
    });
  },
  mounted() {
    // var _this = this;
    // for (let i of _this.$store.state.userList) {
    //   i.isSelected = false;
    //   if (i.name == "全部订单") {
    //     i.isSelected = true;
    //   }
    // }
    // this.$fetch(`order/api/order/${_this.$route.query.orderid}`).then(res => {
    //   if (res.code == 0) {
    //     _this.orderList = res.data;
    //   } else {
    //     this.$message(res.message);
    //   }
    // });
    // this.$fetch(
    //   `order/api/goods_pick_up?oid=${_this.$route.query.orderid}`
    // ).then(res => {
    //   if (res.code == 0) {
    //     _this.abnormalData = res.data;
    //   } else {
    //     this.$message(res.message);
    //   }
    // });
  },

  methods: {
    imgOrVideo,
    setPreviewList(list) {
      return list.map((i) => this.imgOrVideo(i).url);
    },
    // 播放视频
    openVideo(item) {
      console.log(item);
      this.$refs.videoPlay.init({ installVideoUrl: item });
    },
    // 退回商品初始化
    cancelArbitration() {
      this.masterPrice = "";
      this.arbitrationListContent = "";
    },
    // 输入的金额
    rechargeMoney(val) {
      if (val > Number(this.orderList.workerCashIntransit)) {
        this.masterPrice = this.orderList.workerCashIntransit;
      }
    },
    // 加价
    markupCheck(item) {
      var _this = this;
      this.orderInfo = this.orderList;

      if (item == "MARKUP") {
        this.markup = true;
        // this.$post(
        //   `order/api/order/${_this.$route.query.orderid}/solve_exception?solveExceptionWay=${item}`
        // ).then(res => {
        //   if (res.code == 0) {
        //     this.markup = true;
        //   } else {
        //     this.$message(res.message);
        //   }
        // });
      }
      if (item == "BACK") {
        this.arbitration = true;
      }
      if (item == "NORMAL") {
        this.$post(
          `order/api/order/${this.$route.query.orderid}/solve_exception?solveExceptionWay=NORMAL`
        ).then((res) => {
          if (res.code == 0) {
            this.$message({
              message: res.message,
              type: "success",
            });
            this.$router.go(-1);
          } else {
            this.$message(res.message);
          }
        });
      }
    },
    // 返回订单
    submitarbitration() {
      this.$post(
        `order/api/order/${this.$route.query.orderid}/solve_exception?solveExceptionWay=BACK&allowance=${this.masterPrice}&description=${this.arbitrationListContent}`
      ).then((res) => {
        if (res.code == 0) {
          this.arbitration = false;
          this.$router.go(-1);
        } else {
          this.$message(res.message);
        }
      });
    },
    showMarkup(val) {
      this.markup = val;
    },
    increasePrice(val) {},
    passType(item) {
      var _this = this;
      if (item == "password") {
        _this.passwordType = "text";
      }
      if (item == "text") {
        _this.passwordType = "password";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.goods-info {
  // margin-top: 10px;
  .goods {
    background: #fff;
    .goods-tab {
      background: #f9fafa;
      height: 30px;
      font-size: 12px;
      color: #5e6066;
      display: flex;
      div {
        line-height: 31px;
        text-align: center;
      }
      .shang {
        width: 370px;
      }
      .shuliang {
        width: 300px;
      }
      .baozhuang {
        width: 187px;
      }
    }
    .goods-list {
      // margin-top: 10px;
      padding: 10px 20px;
      .item-goods {
        display: flex;
        font-size: 12px;
        color: #2f3133;
        margin-bottom: 10px;
        div {
          display: flex;
          align-items: center;
        }
        img {
          width: 50px;
          height: 50px;
          margin-right: 12px;
        }
        .goods-name {
          width: 310px;
          height: 50px;
        }
        .goods-num {
          width: 300px;
          justify-content: center;
        }
        .bangzhuang {
          width: 187px;
          justify-content: center;
        }
      }
      .item-goods:hover {
        background: #f9fafa;
        cursor: pointer;
      }
    }
    .goods-basic-info {
      padding: 0 20px;
      display: flex;
      font-size: 12px;
      .tabclass {
        margin-right: 60px;
        color: #2f3133;
        .label {
          color: #5e6066;
          margin-right: 10px;
        }
      }
    }

    .markup {
      padding: 0 20px;
      margin-top: 20px;
      font-size: 12px;
      color: #5e6066;
      .markup-item {
        color: #2f3133;
        margin-bottom: 5px;
        span {
          margin-right: 45px;
        }
      }
      .markup-item:nth-child(1) {
        margin-top: 3px;
      }
      .markup-item:last-child {
        margin-bottom: 0;
      }
    }
    .step_one_price {
      margin-top: 10px;
      padding: 0 20px 37px 20px;
      font-size: 12px;
      color: #2f3133;
      margin-bottom: 0;
      .one_tab {
        align-items: flex-end;
      }
      .one_total {
        font-size: 26px;
        height: 26px;
      }
    }
  }
}
#orderlist {
  .applyinfo {
    margin-top: 15px;
    .applyinfo-info {
      background: #ffffff;
      padding: 0 20px 12px 20px;
      overflow: hidden;
      .tabclass {
        margin-top: 12px;
        display: flex;
        flex-wrap: wrap;
        font-size: 12px;
        & > div {
          width: calc(100% - 60px);
        }
        .label {
          width: 60px;
        }

        &/deep/ .el-image {
          & > img {
            width: 83px;
            height: 83px;
            border-radius: 2px;
            margin-right: 8px;
            margin-bottom: 8px;
            object-fit: cover;

            &:nth-child(8n) {
              margin-right: 0;
            }
          }
        }
      }
    }
  }
  .abnormal-btn {
    display: flex;
    justify-content: flex-end;
    margin-top: 24px;
    & /deep/ .el-button {
      width: 190px;
      height: 46px;
      border-radius: 2px;
      border: 1px solid rgba(52, 85, 211, 1);
      color: #3455d3;
      font-size: 20px;
      padding: 0;
      background: transparent;
      &:last-child {
        background: rgba(52, 85, 211, 1);
        color: #ffffff;
      }
    }
  }
  .arbitration {
    .tips {
      height: 14px;
      font-size: 14px;
      color: rgba(247, 86, 88, 1);
      line-height: 14px;
      margin-bottom: 30px;
    }
    .a-title {
      height: 14px;
      font-size: 14px;
      font-weight: bold;
      color: rgba(47, 49, 51, 1);
      line-height: 14px;
      margin-bottom: 24px;
    }
    .arbitration-title {
      color: #2f3133;
    }
  }
}
</style>
